import React from 'react';

import styled from 'styled-components';
import { Icon, Button } from '@roo/roo';
import { Link, useHistory } from 'react-router-dom';
import { useUserData } from '@components/UserData';
import { useSimpleContext } from './_context';
import { tipsTitle } from './_components/Layout';

const Root = styled.div`
  .box {
    width: 100%;
    height: calc(100vh - 60px);
    background-color: #fff;
    text-align: center;
    .ct {
      color: #222;
      position: relative;
      display: inline-block;
      width: 765px;
      top: 50%;
      transform: translateY(-50%);
      height: 300px;
      background-color: #fff;
      text-align: center;
      .title {
        font-size: 20px;
        font-weight: 600;
      }
      .text {
        color: #666;
        font-size: 14px;
      }
    }
  }
`;
const config = {
  innovate: {
    title: '"科创中国"美团青山环保科技创新示范项目',
    menus: ['', '基础信息', '附加信息', '申报信息'],
  },
  scientist: {
    title: '青山科技奖',
    menus: ['', '基础信息', '科研信息', '申报信息'],
  },
};
function Success(props) {
  const { state } = useSimpleContext((t) => [t.formType]);
  const history = useHistory();
  const { refreshUserData } = useUserData();
  const { formType } = state;

  return (
    <Root style={props.style}>
      <div className="box">
        <div className="ct">
          <Icon
            name="check-circle"
            style={{ fontSize: 56, color: '#00BF7F', marginBottom: 10 }}
          />
          <div className="title" style={{ marginBottom: 8 }}>
            {tipsTitle[formType]}
            申报
          </div>
          <div className="title" style={{ marginBottom: 24 }}>
            提交成功
          </div>
          <Button
            type="hollow"
            style={{ color: '#222' }}
            onClick={async () => {
              await refreshUserData();
              history.push({
                pathname: '/preview',
                search: `formType=${formType || 'scientist'}`,
              });
            }}
          >
            查看申报详情
          </Button>
          <Button
            style={{ marginLeft: 16, color: '#fff' }} onClick={
              async () => {
                await refreshUserData();
                history.push({
                  pathname: '/home',
                });
              }
            }
          >
            官网首页
          </Button>
        </div>
      </div>
    </Root>
  );
}

export default Success;
